import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  CompanyFinancialMetricsHeaderRow,
  CompanyFinancialMetricsTableRow
} from 'modules/components/layer22';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';



export const FC = () => {
  const params = useParams();
  const { data, loading } = ds.useQuery(params.companyId);
  const years = data.years.map((r) => r.toString());

  if (loading) {
    return <div />;
  }

  if (!loading && _.isEmpty(data.years)) {
    return (
      <Box sx={{
        display: 'flex',
        p: 2,
        alignItems: 'center',
        justifyContent: 'center'
      }}
      >
        <Typography variant='activityHeader'>No data found.</Typography>
      </Box>
    );
  }

  return (
    <TableContainer>
      <Table
        size='small'
      >
        <TableHead>
          <CompanyFinancialMetricsHeaderRow.FC headerValues={[
            ...years,
            '5 Year avg'
          ]}
          />
        </TableHead>

        <TableBody>
          {/* Price values */}
          {data.pricingSection.map((field, i) => {
            return (
              <CompanyFinancialMetricsTableRow.FC
                years={data.years}
                key={i}
                glAccount={field}
                summary='avg'
              />
            );
          })}

          <CompanyFinancialMetricsHeaderRow.FC headerValues={[
            ...years,
            '5 Year CAGR'
          ]}
          />

          {data.financialsSection.map((field, i) => {
            return (
              <CompanyFinancialMetricsTableRow.FC
                key={i}
                years={data.years}
                glAccount={field}
                summary='cagr'
              />
            );
          })}

          <CompanyFinancialMetricsHeaderRow.FC headerValues={[
            ...years,
            '5 Year avg'
          ]}
          />

          {data.ratioSection.map((field, i) => {
            return (
              <CompanyFinancialMetricsTableRow.FC
                key={i}
                years={data.years}
                glAccount={field}
                summary='avg'
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
